import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';

import styles from './styles';

class WheelButton extends Component {
  state = { isHovered: false };

  handleMouseEnter = () => this.setState({ isHovered: true });

  handleMouseLeave = () => this.setState({ isHovered: false });

  // TODO: Add listener for mouse events, to shrink button on every click to bring
  //       button press sensation

  // TODO: Add thumb rendering logic for friendly icon transition

  render() {
    return (
      <div style={[styles.container, styles[`wheelButtonPositioning${this.props.index}`]]}>
        <UTTouchableWithoutFeedback
          style={[styles.hoverDiv, styles[`hover${this.props.index}`]]}
          onClick={this.props.onClick}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        />
        <UTLabel extrabold xlarge white style={styles[`tag${this.props.index}`]}>
          {`0${this.props.index + 1}`}
        </UTLabel>
        <div style={[styles[`content${this.props.index}`], styles.content]}>
          <div style={styles.iconContainer}>
            <img src={this.props.icon} style={styles.icon} alt="" />
          </div>
          <UTLabel white small extrabold style={styles.description}>
            {this.props.title}
          </UTLabel>
        </div>
        <img
          src={this.state.isHovered ? this.props.imageHovered : this.props.image}
          alt=""
          style={styles.button}
        />
      </div>
    );
  }
}

WheelButton.propTypes = {
  image: PropTypes.string.isRequired,
  imageHovered: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string.isRequired
};

WheelButton.defaultProps = {
  title: ''
};

export default Radium(WheelButton);
